import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import { compile } from 'path-to-regexp';
import { getSuperPartnerBaseURL, getBaseURL } from '@finect/front-utils/env';
import { getURLWithQueryString } from '@finect/front-utils/getURLWithQueryString';
export var getScenePattern = function getScenePattern(theme, sceneId) {
  var _theme$partner$routes = theme.partner.routes,
    partnerRoutes = _theme$partner$routes === void 0 ? {} : _theme$partner$routes;
  if (partnerRoutes.hasOwnProperty(sceneId)) {
    return {
      match: true,
      pattern: partnerRoutes[sceneId]
    };
  }
  var _theme$routes = theme.routes,
    routes = _theme$routes === void 0 ? {} : _theme$routes;
  if (!routes.hasOwnProperty(sceneId)) {
    return null;
  }
  return {
    match: false,
    pattern: routes[sceneId]
  };
};
export var getResourcePath = function getResourcePath(theme, sceneId) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var pattern = getScenePattern(theme, sceneId);
  if (!pattern) {
    return null;
  }
  var compiled = compile(pattern.pattern, {});
  var path = compiled(params);
  var pathWithQuery = getURLWithQueryString(path, query);
  return {
    pattern: pattern,
    path: pathWithQuery,
    url: pattern.match ? getBaseURL() + pathWithQuery : getSuperPartnerBaseURL() + pathWithQuery,
    superPartnerURL: getSuperPartnerBaseURL() + pathWithQuery
  };
};
export var getResourceLocation = function getResourceLocation(theme, sceneId) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var resource = getResourcePath(theme, sceneId, params, query);
  return resource ? resource.path : '#';
};